import React from 'react';
import { createRoot } from 'react-dom/client';
import { loadDesignSystem } from './ds';
import { RouterProvider } from './router';
import { I18nProvider } from './i18n';
import { AppProvider } from './state';
import { App } from './App';
import './styles.css';

// Nothing of Cloud frames this app, and the one page another site may frame,
// `/bridge`, is its own entry without it. If this ever runs in a frame, a
// request meant for that page was answered with this one: stop before anything
// reads the session or restores a vault.
if (window.top !== window.self) throw new Error('Mauvely Cloud does not open in a frame.');

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

const root = createRoot(container);

// The design system bundle registers its components on a global and every page
// renders them, so mounting before it resolves would throw. Waiting here keeps
// every component free of load-state checks.
loadDesignSystem()
  .then(() => {
    root.render(
      <React.StrictMode>
        <RouterProvider>
          <I18nProvider>
            <AppProvider>
              <App />
            </AppProvider>
          </I18nProvider>
        </RouterProvider>
      </React.StrictMode>
    );
  })
  .catch((err) => {
    console.error(err);
    root.render(
      <div
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          padding: 40,
          background: 'var(--bg-page)',
          fontFamily: 'Inter, sans-serif',
          textAlign: 'center'
        }}
      >
        <div>
          <h1 style={{ fontFamily: "'Baloo 2', sans-serif", fontSize: 28 }}>
            Something did not load.
          </h1>
          <p style={{ color: 'var(--text-muted)', maxWidth: 440 }}>
            The design system bundle could not be fetched. Reload the page, and if it keeps
            happening the deployment is missing <code>/_ds/mauvely/_ds_bundle.js</code>.
          </p>
        </div>
      </div>
    );
  });
